import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil } from 'ng-jhipster';

import { UserRouteAccessService } from '../../shared';
import { DeviceSchemaComponent } from './device-schema.component';
import { DeviceSchemaDetailComponent } from './device-schema-detail.component';
import { DeviceSchemaPopupComponent } from './device-schema-dialog.component';
import { DeviceSchemaDeletePopupComponent } from './device-schema-delete-dialog.component';

@Injectable()
export class DeviceSchemaResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: JhiPaginationUtil) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
      };
    }
}

export const deviceSchemaRoute: Routes = [
    {
        path: 'device-schema',
        component: DeviceSchemaComponent,
        resolve: {
            'pagingParams': DeviceSchemaResolvePagingParams
        },
        data: {
            authorities: ['ROLE_ORG_ADMIN'],
            pageTitle: 'balrogadminApp.deviceSchema.home.title'
        },
        canActivate: [UserRouteAccessService]
    }, {
        path: 'device-schema/:id',
        component: DeviceSchemaDetailComponent,
        data: {
            authorities: ['ROLE_ORG_ADMIN'],
            pageTitle: 'balrogadminApp.deviceSchema.home.title'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const deviceSchemaPopupRoute: Routes = [
    {
        path: 'device-schema-new',
        component: DeviceSchemaPopupComponent,
        data: {
            authorities: ['ROLE_ORG_ADMIN'],
            pageTitle: 'balrogadminApp.deviceSchema.home.title'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'device-schema/:id/edit',
        component: DeviceSchemaPopupComponent,
        data: {
            authorities: ['ROLE_ORG_ADMIN'],
            pageTitle: 'balrogadminApp.deviceSchema.home.title'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'device-schema/:id/delete',
        component: DeviceSchemaDeletePopupComponent,
        data: {
            authorities: ['ROLE_ORG_ADMIN'],
            pageTitle: 'balrogadminApp.deviceSchema.home.title'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
